import { linkLogin, linkSignUp } from 'design-studio/lib'

/**
 * Site URL + label map (same role as imandrax.dev `src/site/data-links.ts`).
 * Sign-in hrefs come from imandra navigation JSON via `design-studio/lib` (sub/design-studio).
 */
export const NavigationData = {
  home: { name: 'Home', href: '/', 'aria-label': 'Navigate to Home' },
  docs: {
    name: 'Docs',
    href: '/docs/',
    'aria-label': 'Docs',
  },
  contact: {
    name: 'Contact',
    href: 'https://www.imandra.ai/contact',
    'aria-label': 'Contact us',
  },
  login: {
    name: 'Login',
    href: linkLogin,
    'aria-label': 'Login to Imandra Universe',
  },
  signup: {
    name: 'Sign up',
    href: linkSignUp,
    'aria-label': 'Sign up for Imandra Universe',
    /** Hero CTA line (header CTA uses `name`). */
    heroLabel: 'Start Now',
  },
} as const

export { DataFooterLinks } from 'design-studio'
